export enum ErrorIconEnum {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}
